import { axiosInstance, getError } from "@dexteel/mesf-core";

export const THRESHOLD = "XML_SOURCE_FAILURE_THRESHOLD";
export const SILENCE = "XML_SERVICE_SILENCE_SECONDS";
export const RETENTION = "XML_FILES_RETENTION_DAYS";

// camelCase: these come from C# classes, and AddNewtonsoftJson camel-cases their
// properties. Rows() dictionaries elsewhere in the app keep their column names,
// which is why other repositories in here are PascalCase.
export type XmlSetting = {
	settingName: string;
	value: string;
	description: string | null;
};

export type XmlSettings = {
	settings: XmlSetting[];
	// Reported by the feed: turns a threshold in checks into a threshold in time.
	loopSeconds: number | null;
};

export type PurgeImpact = {
	cutoff: string;
	rowsToDelete: number;
	oldestAffected: string | null;
	newestAffected: string | null;
};

export const getXmlSettings = async () => {
	try {
		const resp = await axiosInstance.get("Broker/settings");
		return { ok: true, data: resp.data as XmlSettings };
	} catch (e) {
		return { ok: false, message: getError(e), data: null };
	}
};

export const getPurgeImpact = async (days: number) => {
	try {
		const resp = await axiosInstance.get("Broker/settings/purge-impact", {
			params: { days },
		});
		return { ok: true, data: resp.data as PurgeImpact | null };
	} catch (e) {
		return { ok: false, message: getError(e), data: null };
	}
};

export const setXmlSetting = async (settingName: string, value: string) => {
	try {
		await axiosInstance.post("Broker/settings", { settingName, value });
		return { ok: true, message: "", rejected: false };
	} catch (e) {
		const status = (e as { response?: { status?: number } })?.response?.status;
		return { ok: false, message: getError(e), rejected: status === 400 };
	}
};
